import { render, staticRenderFns } from "./SectionSelectionLink.vue?vue&type=template&id=ffc93694&scoped=true&lang=html&"
import script from "./SectionSelectionLink.vue?vue&type=script&lang=js&"
export * from "./SectionSelectionLink.vue?vue&type=script&lang=js&"
import style0 from "./SectionSelectionLink.vue?vue&type=style&index=0&id=ffc93694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc93694",
  null
  
)

export default component.exports